import { ReactElement } from 'react';

import { ComplexLayoutProps, BaseHeaderProps } from '@localstack/types';
import { BaseHeader } from '@localstack/ui';

import { LayoutContainer } from '../LayoutContainer';

import { CustomerLayout, CustomerLayoutProps } from './CustomerLayout';

type ContainedCustomerLayoutProps = ComplexLayoutProps & CustomerLayoutProps & BaseHeaderProps;

export const ContainedCustomerLayout = ({
  title,
  fullScreen,
  maxWidth,
  breadcrumbs,
  maturityLevel,
  links,
  dropdownActions,
  actions,
  children,
  ...rest
}: ContainedCustomerLayoutProps): ReactElement => (
  <CustomerLayout {...rest} title={title}>
    <BaseHeader
      // Fallback logic for breadcrumbs:
      // – If `breadcrumbs` is provided, use it.
      // – Otherwise, if `title` is a string, create a single breadcrumb from it.
      // – If neither is available, leave breadcrumbs undefined.
      breadcrumbs={breadcrumbs || (title && typeof title === 'string' ? [{ label: title }] : undefined)}
      maturityLevel={maturityLevel}
      links={links}
      dropdownActions={dropdownActions}
      actions={actions}
    />
    <LayoutContainer fullScreen={fullScreen} maxWidth={maxWidth}>
      {children}
    </LayoutContainer>
  </CustomerLayout>
);
